var map = {
	"./call.svg": 447,
	"./github.svg": 454,
	"./logo-basic.svg": 455,
	"./logo-clipped.svg": 445,
	"./logo.svg": 456,
	"./podium.svg": 457,
	"./schedule.svg": 458,
	"./sponsors/aranja.svg": 459,
	"./sponsors/bloomberg.svg": 460,
	"./sponsors/mozilla.svg": 461,
	"./sponsors/tempo.svg": 462,
	"./ticket.svg": 463,
	"./tonkvisl.svg": 464,
	"./twitter.svg": 465
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;



/*****************
 ** WEBPACK FOOTER
 ** ../images ../~/svg-inline-loader!^\.\/.*\.svg$
 ** module id = 453
 ** module chunks = 0
 **/